export default {
    getGiftee (state) {
        return state.giftee
    },
    getSelectedGiftId (state) {
        return state.selectedGiftId
    },
    getCorporateClients (state) {
        return state.corporateClients
    },
    getCorporateClientPlanId (state) {
        return state.corporateClientPlanId
    },
    getCorporateClientForDemo (state) {
        return state.corporateClientForDemo
    },
    getCorporateClient (state) {
        if (state.corporateClient) {
            return state.corporateClient
        } else if (localStorage.getItem('corporateClientObject')) {
            state.corporateClient = JSON.parse(localStorage.getItem('corporateClientObject'))
            return state.corporateClient
        } else {
            return null
        }
    },
    getGiftingError (state) {
        return state.giftingError
    },
    getCorpHeaderColor (state) {
        return state.corpHeaderColor
        // let headerColor = '#f0617d'
        // let loggedUser = null
        // if (localStorage.getItem('loggedUser')) {
        //     loggedUser = JSON.parse(localStorage.getItem('loggedUser'))
        // }
        // if (loggedUser) { // Logged In User
        //     if (loggedUser && loggedUser.corporation && loggedUser.corporation.groupDefinitions && loggedUser.corporation.groupDefinitions.headerColor) {
        //         headerColor = loggedUser.corporation.groupDefinitions.headerColor
        //     }
        // } else { // Unauth User
        //     if (!loggedUser) { // User is not logge in, check if corp has custom theme
        //         if (sessionStorage.getItem('corporateClientObject')) {
        //             let corpObject = JSON.parse(sessionStorage.getItem('corporateClientObject'))
        //             if (corpObject && corpObject.groupDefinitions && corpObject.groupDefinitions.headerColor) {
        //                 headerColor = corpObject.groupDefinitions.headerColor
        //                 // state.corpHeaderColor = corpObject.corpgroupDefinitions.headerColor
        //             }
        //         }
        //     }
        // }
        // console.log('new header color', headerColor)
        // return headerColor
    },
    getCorpFooterColor (state) {
        return state.corpFooterColor
        // let footerColor = '#f0617d'
        // let loggedUser = null
        // if (localStorage.getItem('loggedUser')) {
        //     loggedUser = JSON.parse(localStorage.getItem('loggedUser'))
        // }
        // if (loggedUser) { // Logged In User
        //     if (loggedUser && loggedUser.corporation && loggedUser.corporation.groupDefinitions && loggedUser.corporation.groupDefinitions.footerColor) {
        //         footerColor = loggedUser.corporation.groupDefinitions.footerColor
        //     }
        // } else { // Unath User
        //     if (!loggedUser) { // User is not logge in, check if corp has custom theme
        //         if (sessionStorage.getItem('corporateClientObject')) {
        //             let corpObject = JSON.parse(sessionStorage.getItem('corporateClientObject'))
        //             if (corpObject && corpObject.groupDefinitions && corpObject.groupDefinitions.footerColor) {
        //                 footerColor = corpObject.groupDefinitions.footerColor
        //             }
        //         }
        //     }
        // }
        // return footerColor
    },
    getCorpButtonColor (state) {
        return state.corpButtonColor
        // let buttonColor = '#f0617d'
        // let loggedUser = null
        // if (localStorage.getItem('loggedUser')) {
        //     loggedUser = JSON.parse(localStorage.getItem('loggedUser'))
        // }
        // if (loggedUser) { // Logged In User
        //     if (loggedUser && loggedUser.corporation && loggedUser.corporation.groupDefinitions && loggedUser.corporation.groupDefinitions.buttonColor) {
        //         buttonColor = loggedUser.corporation.groupDefinitions.buttonColor
        //     }
        // } else { // Unath User
        //     if (!loggedUser) { // User is not logge in, check if corp has custom theme
        //         if (sessionStorage.getItem('corporateClientObject')) {
        //             let corpObject = JSON.parse(sessionStorage.getItem('corporateClientObject'))
        //             if (corpObject && corpObject.groupDefinitions && corpObject.groupDefinitions.buttonColor) {
        //                 buttonColor = corpObject.groupDefinitions.buttonColor
        //             }
        //         }
        //     }
        // }
        // return buttonColor
    },
    getCorpHeadingColor (state) {
        return state.corpHeadingColor
        // let headingColor = '#f0617d'
        // let loggedUser = null
        // if (localStorage.getItem('loggedUser')) {
        //     loggedUser = JSON.parse(localStorage.getItem('loggedUser'))
        // }
        // if (loggedUser) { // Logged In User
        //     if (loggedUser && loggedUser.corporation && loggedUser.corporation.groupDefinitions && loggedUser.corporation.groupDefinitions.headingColor) {
        //         headingColor = loggedUser.corporation.groupDefinitions.headingColor
        //     }
        // } else { // Unath User
        //     if (!loggedUser) { // User is not logge in, check if corp has custom theme
        //         if (sessionStorage.getItem('corporateClientObject')) {
        //             let corpObject = JSON.parse(sessionStorage.getItem('corporateClientObject'))
        //             if (corpObject && corpObject.groupDefinitions && corpObject.groupDefinitions.headingColor) {
        //                 headingColor = corpObject.groupDefinitions.headingColor
        //             }
        //         }
        //     }
        // }
        // console.log('heading color', headingColor)
        // return headingColor
    },
    getParentCorporation (state) {
        return state.parentCorporation
    },
    getCorpRestrictedRegions (state) {
        return state.corpRestrictedRegions
    },
    getCorporationRegions (state) {
        return state.corporationRegions
    },
    getSwitchCorporateClient (state) {
        return state.SwitchCorporateClient
    },
    getCorporateGiftInfo (state) {
        if (state.corporateGiftInfo) {
            return state.corporateGiftInfo
        } else if (localStorage.getItem('corporateGiftInfoObject')) {
            state.corporateGiftInfo = JSON.parse(localStorage.getItem('corporateGiftInfoObject'))
            return state.corporateGiftInfo
        } else {
            return null
        }
    }
}



// WEBPACK FOOTER //
// ./src/store/gifts/getters.js